import { render, staticRenderFns } from "./EditRole.vue?vue&type=template&id=8911e04c&scoped=true&"
import script from "./EditRole.vue?vue&type=script&lang=js&"
export * from "./EditRole.vue?vue&type=script&lang=js&"
import style0 from "./EditRole.vue?vue&type=style&index=0&id=8911e04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8911e04c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VContainer,VForm})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8911e04c')) {
      api.createRecord('8911e04c', component.options)
    } else {
      api.reload('8911e04c', component.options)
    }
    module.hot.accept("./EditRole.vue?vue&type=template&id=8911e04c&scoped=true&", function () {
      api.rerender('8911e04c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EditRole.vue"
export default component.exports